"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var admin_tabs_1 = require("../../../../experiences/pharmacy-pricing-experience/tabs/admin-tabs/admin-tabs");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var default_view_1 = require("../../../primitives/default-view");

var pricing_header_1 = require("../../pricing-header/pricing-header");

var heading_1 = require("../../text/heading/heading");

var busy_overlay_1 = require("../busy-overlay/busy-overlay");

var error_panel_1 = require("../error-panel/error-panel");

var message_panel_1 = require("../message-panel/message-panel");

var successMessagePanelViewStyle = {
  alignSelf: 'center',
  margin: '1rem',
  position: 'fixed',
  top: '30%',
  width: '60vw'
};

var Page = function (_super) {
  __extends(Page, _super);

  function Page() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.scrollViewRef = react_1.default.createRef();

    _this.scrollToBottom = function () {
      var scrollViewRef = _this.scrollViewRef.current;

      if (scrollViewRef) {
        scrollViewRef.scrollToEnd();
      }
    };

    _this.scrollToTop = function () {
      var scrollViewRef = _this.scrollViewRef.current;

      if (scrollViewRef) {
        scrollViewRef.scrollTo();
      }
    };

    return _this;
  }

  Page.prototype.render = function () {
    return react_1.default.createElement(react_native_1.ScrollView, {
      ref: this.scrollViewRef,
      style: theme_pricing_system_1.pricingStyles.pageWrapperViewStyle
    }, react_1.default.createElement(pricing_header_1.PricingHeader, {
      isAdmin: this.props.isAdmin,
      currentGroup: this.props.currentGroup,
      showPharmacyGroup: this.props.showPharmacyGroup,
      onGroupSelect: this.props.onGroupSelect
    }), this.renderNotification(), this.renderTabs(), react_1.default.createElement(default_view_1.DefaultView, {
      accessibilityRole: "main",
      style: [theme_pricing_system_1.pricingStyles.pageViewStyle, this.props.viewStyle]
    }, this.renderPageTitle(this.props.title), this.props.children), this.renderErrorMessage(), this.renderInfoMessage(), react_1.default.createElement(busy_overlay_1.BusyOverlay, {
      showBusy: this.props.showBusy
    }));
  };

  Page.prototype.renderNotification = function () {
    var notification = this.props.notification;

    if (!notification) {
      return null;
    }

    return react_1.default.createElement(react_native_1.Text, {
      style: theme_pricing_system_1.pricingStyles.pageNotificationTextStyle
    }, notification);
  };

  Page.prototype.renderTabs = function () {
    if (!this.props.isAdmin) {
      return null;
    }

    return react_1.default.createElement(admin_tabs_1.AdminTabs, {
      selectedTabValue: this.props.selectedTabValue,
      showRulesTab: this.props.showRulesTab
    });
  };

  Page.prototype.renderPageTitle = function (title) {
    if (title) {
      return react_1.default.createElement(heading_1.Heading, {
        textStyle: theme_pricing_system_1.pricingStyles.pageHeadingTextStyle
      }, title);
    }

    return null;
  };

  Page.prototype.renderErrorMessage = function () {
    if (!this.props.error) {
      return null;
    }

    this.scrollToTop();
    var error = this.props.error.error;
    var errorType = typeof error;
    var contextId = errorType === 'number' ? Number(error) : undefined;
    var message = errorType !== 'number' ? error : undefined;
    return react_1.default.createElement(error_panel_1.ErrorPanel, {
      heading: this.props.error.heading,
      contextId: contextId,
      message: message,
      onClose: this.props.onErrorClose
    });
  };

  Page.prototype.renderInfoMessage = function () {
    if (!this.props.infoMessage) {
      return null;
    }

    return react_1.default.createElement(message_panel_1.MessagePanel, {
      isFading: true,
      content: this.props.infoMessage,
      onFaded: this.props.onMessageFaded,
      viewStyle: successMessagePanelViewStyle
    });
  };

  return Page;
}(react_1.default.Component);

exports.Page = Page;